import { UiType } from '../schematics/ui/schema';

// add selected elements to this array, then values are available in other schematics
export const selectedElements: UiType[] = [];
